// HOME
export const DEROM_ENABLED = 'Derom.Enabled';
export const CA_ENABLED = 'CA.Chatbot.Enabled';

// HSG
export const KAKI_ENABLED = 'KAKI.Enabled';
export const KAKI_INTERVAL = 'KAKI.RefreshInterval';

// PAYMENT SETTINGS
export const CREDIT_ENABLED = 'Credit.Onemid.Enabled';
export const DEBIT_ENABLED = 'Debit.Onemid.Enabled';
export const AMEX_ENABLED = 'Amex.Onemid.Enabled';
export const MOBILE_PAYMENT_CALLBACK_REDIRECT_URL = 'Mobile.PaymentService.2C2P.FrontendCallbackUrl';

export const APPOINTMENT_MAINTENANCE_SOURCEAPP = 'Appointment.ImportantNote.Maintenance.SourceApp';

export const VideoConsultSettings = {
  ValidServiceTypeDetails: 'Appointment.VC.ValidServiceTypeDetails',
  NuhsLearnTeleconsultLink: 'Appointment.VC.NuhsLearnTeleconsultLink',
} as const;

export const DoctorConsultApptSettings = {
  AvailabilityFrom: 'Appointment.DoctorConsult.Availability.From',
  AvailabilityTo: 'Appointment.DoctorConsult.Availability.To',
} as const;

export const DentalApptDepositSettings = {
  ForfeitDays: 'Appointment.DentalDeposit.ForfeitDays',
  ServiceTypes: 'Appointment.DentalServiceTypeId',
} as const;

export const ScreeningEissDateConfiguration = 'Appointments.Screening.EissDateConfiguration';
